import { ProductType } from '@constant/ProductType';
import { useRouter } from 'next/router';
import {
  buildCatalogPdpPath,
  buildPdpPath,
  buildSupplementPdpPath,
  getProductId,
} from '@utilities/catalog/paths';
import { getCatalogPlpContextFromPath } from '@utilities/catalog/sections';

type ProductTypeId =
  | ProductType.RX
  | ProductType.Otc
  | ProductType.RequestOrder
  | ProductType.Supplement;

interface INavigateToProduct {
  ProductTypeId: ProductTypeId;
  item: any;
  searchQuery?: {
    brandName?: string;
    categoryCodeLevel3?: string;
    fromShopping?: boolean;
  };
}

const useProductNavigation = () => {
  const { push, asPath } = useRouter();

  const navigateToPdp = ({
    item,
    ProductTypeId,
    searchQuery,
  }: INavigateToProduct) => {
    const productId = getProductId(item);
    const isFromShopping = Boolean(searchQuery?.fromShopping || item?.price);
    const brandName = searchQuery?.brandName ?? item?.brandName;
    const categoryCodeLevel3 =
      searchQuery?.categoryCodeLevel3 ?? item?.categoryCodeLevel3;
    const shoppingQuery = isFromShopping
      ? {
          fromShopping: true,
          ...(brandName ? { brandName } : {}),
          ...(categoryCodeLevel3 ? { categoryCodeLevel3 } : {}),
        }
      : undefined;

    if (ProductTypeId === ProductType.RX) {
      console.error('not implemented');
      return null;
    }

    if (ProductTypeId === ProductType.Supplement) {
      if (isFromShopping) {
        return push(
          buildSupplementPdpPath(productId, item?.productName, shoppingQuery),
        );
      }

      const plpContext = getCatalogPlpContextFromPath(asPath);
      if (plpContext) {
        return push(
          buildCatalogPdpPath(
            plpContext.plpBasePath,
            plpContext.productListName,
            productId,
            item?.productName,
          ),
        );
      }

      return push(buildSupplementPdpPath(productId, item?.productName));
    }

    if (isFromShopping) {
      return push(buildPdpPath(productId, item?.productName, shoppingQuery));
    }

    return push(buildPdpPath(productId, item?.productName));
  };

  return { navigateToPdp };
};

export default useProductNavigation;
